import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const LogsFilter = ({
  bppId,
  setBppId,
  messageId,
  setMessageId,
  transactionId,
  setTransactionId,
  actionType,
  setActionType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  actionOptions,
  bapOptions,
  domainOptions,
  domain,
  setDomain,
}) => {
  return (
    <div className="row">
      <div className="col-4 buyerAppDropDownRoot">
        <label className="formLabels mb-1">Buyer App Id</label>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={bppId}
          // label="bppId"
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em>Select Buyer App</em>;
            }

            return selected;
          }}
          onChange={(e) => setBppId(e.target.value)}
        >
          {bapOptions.map((bap) => {
            return <MenuItem value={bap.value}>{bap.value}</MenuItem>;
          })}
        </Select>
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Transaction Id</label>
        <input
          type="text"
          value={transactionId}
          id="transactionId"
          name="transactionId"
          onChange={(e) => setTransactionId(e.target.value)}
          placeholder="Search transaction id"
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Message Id</label>
        <input
          type="text"
          value={messageId}
          id="messageId"
          name="messageId"
          onChange={(e) => setMessageId(e.target.value)}
          placeholder="Search message id"
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Action</label>
        <select
          id="status"
          className="form-select"
          aria-label="Default select example"
          value={actionType}
          onChange={(e) => setActionType(e.target.value)}
        >
          <option value="">Select Option</option>
          {actionOptions && actionOptions.length
            ? actionOptions.map((action) => {
                return <option value={action}>{action}</option>;
              })
            : null}
        </select>
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Domain</label>
        <select
          id="domain"
          className="form-select"
          aria-label="Default select example"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
        >
          <option value="">Select Option</option>
          {domainOptions && domainOptions.length
            ? domainOptions.map((domain) => {
                return <option value={domain.code}>{domain.domain}</option>;
              })
            : null}
        </select>
      </div>

      {/* <div className="col-2">
        <label className="formLabels mb-1">Start From</label>
        <input
          type="date"
          value={startDate || ""}
          id="dateFrom"
          name="dateFrom"
          onChange={(e) => setStartDate(e.target.value)}
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">End To</label>
        <input
          type="date"
          value={endDate || ""}
          id="dateTo"
          name="dateTo"
          onChange={(e) => setEndDate(e.target.value)}
          className="form-control"
        />
      </div> */}
    </div>
  );
};

export default LogsFilter;
